export default __webpack_public_path__ + "static/media/Resource-Icons-Birth-transparent.0008a26c.png";